import {user} from '../../utils.js';
import {HomeDeliveryBIModel} from '../models/HomeDeliveryBIModel.js';
import {track} from '../../tracking/bi-track';
import {EVENT_HOME_DELIVERY} from '../../events/triggers/home-delivery.js';

export const homeDeliverySelectedBIEventListener = () => {
    document.addEventListener(EVENT_HOME_DELIVERY, (homeDeliveryEvent) => {
        const homeDeliveryBIModel = HomeDeliveryBIModel.createFromDomainEvent(user.id, homeDeliveryEvent);
        track(homeDeliveryBIModel);
    });
};